angular.module("Main").controller("OnlineSalesMembershipsPanelController", ["$scope", "$q", "$translate", "$window", "BookingService",
    function ($scope, $q, $translate, $window, BookingService) {
        let vm = this;
        vm.parent = $scope.$parent.vm;

        vm.limitLength = getLimits();
        vm.mandantNr = vm.parent.selectedMandantNr;
        if (vm.parent.choosenClub && (!vm.mandantNr || _.isUndefined(vm.mandantNr))) {
            vm.mandantNr = vm.parent.selectedClub.MandantNr;
        }
        vm.changedMitgliedschaft = false;
        vm.angebot = vm.parent.angebot;
        vm.begin = 0;
        vm.getRight = false;
        vm.inclZusatztarife = [];
        vm.inclPauschalen = [];
        vm.inclGebuehren = [];
        vm.uuid = vm.parent.uuid;
        vm.noMatched = false;
        vm.selectedSurvey = [];
        //vm.surveySelected = null;
        vm.onlineSalesConfig = vm.parent.onlineSalesConfig;
        vm.layoutColors = vm.parent.layoutColors;
        vm.member = vm.parent.selectedMember;
        vm.memberSelected = vm.parent.memberSelected;
        if (vm.memberSelected || vm.member) {
            vm.member.birthday = new Date(vm.member.birthday);
        }
        if(!vm.memberSelected) {
            vm.selectedMandant = vm.parent.selectedMandant;
        }
        vm.choosenMembershipIndexOrig = vm.parent.choosenMembershipIndex;
        vm.choosenMembershipIndex = vm.parent.choosenMembershipIndex;
        vm.chooseKostenpflichtig = false;
        vm.chooseAngebot = false;
        vm.choosenMemberAngebot = vm.parent.choosenMemberAngebot;
        vm.selectedFoundAngebot = vm.parent.selectedFoundAngebot;
        vm.choosenNewangebotForMember = vm.parent.choosenNewangebotForMember;
        vm.choosenMemberAngebotDatum = vm.parent.choosenMemberAngebotDatum;
        vm.selectedFoundAngebotDatum = vm.parent.selectedFoundAngebotDatum;
        vm.selectedMembershipAdds = vm.parent.selectedMembershipAdds;
        vm.selectedMandantNr = vm.parent.selectedMandantNr;
        vm.selectedPauschalenWithMembershipZyklus = vm.parent.selectedPauschalenWithMembershipZyklus;
        vm.selectedPauschalenWithMembershipZyklusIds = vm.parent.selectedPauschalenWithMembershipZyklusIds;

        let cycleUnits = BookingService.getCycleUnits();
        let allMembershipData = null;

        vm.initialLoading = true;
        BookingService.loadMembershipsOnlineSalesLinkConfig(vm.mandantNr, vm.uuid).then(function (membershipData) {
            vm.noMatched = false;
            if (membershipData.LinkIdNotFound === true) {
                vm.idNotFound = true;
            } else if (membershipData.IsInactiv === true) {
                vm.OSMInactiv = true;
                vm.isInFuture = membershipData.IsInFuture;
                vm.isInPast = membershipData.IsInPast;
                if (membershipData.IsInFuture === true) {
                    vm.futureDate = membershipData.FutureDate;
                }
            } else {
                allMembershipData = membershipData;

                _.forEach(allMembershipData, function (ms) {
                    ms.LaufzeitName = parseUnits(ms.Laufzeit, ms.Laufzeiteinheit);
                    ms.ZahlzyklusName = parseCycles(ms.Zahlzyklus, ms.ZahlzyklusEinheit);
                    ms.Loaded = false;
                });

                vm.showMover = (allMembershipData.length > vm.limitLength);

                let membershipNrs = _.uniq(_.map(allMembershipData, "MitgliedschaftsNr"));
                return BookingService.getMembershipsByNrs(membershipNrs);
            }
        }).catch(function () {
            vm.noMatched = true;
            vm.membershipsOptions = []; // TODO: evtl. Fehleranzeige
        }).then(function (memberships) {
            vm.memberships = memberships;
            return BookingService.getPaymentMethods();
        }).then(function (paymentMethods) {
            _.forEach(allMembershipData, function (data) {
                data.ZahlartNr = vm.memberships[data.MitgliedschaftsNr].ZahlartNr;
                data.Mindestalter = vm.memberships[data.MitgliedschaftsNr].Mindestalter;
                data.Maximalalter = vm.memberships[data.MitgliedschaftsNr].Maximalalter;
                data.Zusatzbeschreibung = vm.memberships[data.MitgliedschaftsNr].Zusatzbeschreibung;
                data.BerechneTeilbetrag = vm.memberships[data.MitgliedschaftsNr].BerechneTeilbetrag;
                if (paymentMethods[data.ZahlartNr]) {
                    data.IstLastschrift = paymentMethods[data.ZahlartNr].IstLastschrift;
                    data.ZahlartBezeichnung = paymentMethods[data.ZahlartNr].Bezeichnung;
                }
            });

            vm.current = [];

            let displayCount = ($window.innerWidth >= 700) ? vm.limitLength : allMembershipData.length;
            for (let i = 0; i < allMembershipData.length; ++i) {
                if (allMembershipData[i]) {
                    if (allMembershipData[i].MitgliedschaftsNr === '1') {
                        allMembershipData[i].BorderColor = "5px solid #00acac !important"
                    }
                    let filter = _.filter(vm.memberships, {Id: allMembershipData[i].MitgliedschaftsNr});
                    let festerVertragsbeginn = filter[0];
                    allMembershipData[i].FesterVertragsbeginn = festerVertragsbeginn ? festerVertragsbeginn.FesterVertragsbeginn : null;
                }
            }
            for (let i = 0; i < displayCount; ++i) {
                if (allMembershipData[i]) {
                    vm.current[i] = allMembershipData[i];
                    loadPrices(i);
                }
            }
            vm.sortedCurrent = _.sortBy(vm.current, 'Sortierung')
            if (vm.choosenMembershipIndex) {
                vm.selectedSurvey.push(vm.parent.selectedSurvey);
            }
            else if (vm.parent.selectedMembership && vm.parent.selectedMembership.AngebotId) {
                _.forEach(allMembershipData, function (a) {
                    let findSurvey = _.find(allMembershipData, [{
                        'MitgliedschaftsNr': vm.parent.selectedMembership.MitgliedschaftsNr,
                        'Laufzeit': vm.parent.selectedMembership.Laufzeit,
                        'Laufzeiteinheit': vm.parent.selectedMembership.Laufzeiteinheit,
                        'Zahlzyklus': vm.parent.selectedMembership.Zahlzyklus,
                        'ZahlzyklusEinheit': vm.parent.selectedMembership.ZahlzyklusEinheit
                    }]);

                    if (a.MitgliedschaftsNr === vm.parent.selectedMembership.MitgliedschaftsNr && a.Laufzeit === vm.parent.selectedMembership.Laufzeit &&
                        a.Laufzeiteinheit === vm.parent.selectedMembership.Laufzeiteinheit && a.Zahlzyklus === vm.parent.selectedMembership.Zahlzyklus &&
                        a.ZahlzyklusEinheit === vm.parent.selectedMembership.ZahlzyklusEinheit) {
                        a.AngebotId = vm.parent.selectedMembership.AngebotId;
                        vm.selectedSurvey.push(a);
                        vm.isSelectedSurvey = true;

                    }

                })
                const index = allMembershipData.findIndex(a => {
                    return (a.MitgliedschaftsNr === vm.parent.selectedMembership.MitgliedschaftsNr && a.Laufzeit === vm.parent.selectedMembership.Laufzeit &&
                        a.Laufzeiteinheit === vm.parent.selectedMembership.Laufzeiteinheit && a.Zahlzyklus === vm.parent.selectedMembership.Zahlzyklus &&
                        a.ZahlzyklusEinheit === vm.parent.selectedMembership.ZahlzyklusEinheit)
                });
                vm.choosenMembershipIndex = index;
                vm.choosenMembershipIndexOrig = index;
            }
            vm.chunked = _.chunk(allMembershipData, vm.limitLength);
            vm.lengthChunked = (vm.chunked).length;
            vm.initialLoading = false;
        }).catch(function () {
            vm.initialLoading = false;
            // TODO: Fehler
        });

        vm.moveLeft = function () {
            vm.begin--;
            if (vm.begin < 0) {
                vm.begin = vm.lengthChunked - 1;
            }
            vm.current = vm.chunked[vm.begin];

            _.forEach(vm.current, function (m) {
                let index = _.findIndex(allMembershipData, m);
                loadPrices(index)
            })
        };

        vm.moveRight = function () {
            vm.begin++;
            if (vm.begin === vm.lengthChunked) {
                vm.begin = 0;
            }
            vm.current = vm.chunked[vm.begin];

            _.forEach(vm.current, function (m) {
                let index = _.findIndex(allMembershipData, m);
                loadPrices(index)
            })

        };

        function loadPrices(index) {
            allMembershipData[index].priceIsLoading = true;
            BookingService.getMembershipPrices(allMembershipData[index].MitgliedschaftsNr,
                allMembershipData[index].LaufzeitNr, allMembershipData[index].ZahlzyklusNr)
                .then(function (prices) {
                    allMembershipData[index].Prices = prices;
                    allMembershipData[index].Inklusiv = [];
                    allMembershipData[index].ServicesWithoutPrice = checkFreeServices(prices);
                    allMembershipData[index].Loaded = true;
                    allMembershipData[index].priceIsLoading = false;
                    vm.pauschalenZyklen = {};

                    _.forEach(allMembershipData[index].Prices.Pauschalenpreise, function (v, k) {
                        let f = (_.find(vm.memberships[allMembershipData[index].MitgliedschaftsNr].Pauschalen, {'Id': k}));
                        vm.memberships[allMembershipData[index].MitgliedschaftsNr].Pauschalen[k].Zahlzyklus = parseCycles(f.Zyklus, f.Zykluseinheit);
                    });
                    _.forEach(prices.Zusatztarifpreise, function (v, k) {
                        let f = (_.find(vm.memberships[allMembershipData[index].MitgliedschaftsNr].Zusatztarife, {'Id': k}));
                        if (f) {
                            if (v === 0) {
                                allMembershipData[index].Inklusiv.push({
                                    Bezeichnung: f.Bezeichnung,
                                    Sortierung: f.Sortierung,
                                    Reihenfolge: 1
                                });
                            }
                        }
                    });
                    _.forEach(prices.Pauschalenpreise, function (v, k) {
                        let f = (_.find(vm.memberships[allMembershipData[index].MitgliedschaftsNr].Pauschalen, {'Id': k}));
                        if (f) {
                            if (v === 0) {
                                allMembershipData[index].Inklusiv.push({
                                    Bezeichnung: f.Bezeichnung,
                                    Sortierung: f.Sortierung,
                                    Reihenfolge: 3
                                });
                            }
                        }
                    });
                    _.forEach(prices.Gebuehrenpreise, function (v, k) {
                        let f = (_.find(vm.memberships[allMembershipData[index].MitgliedschaftsNr].Gebuehren, {'Id': k}));
                        if (f) {
                            if (v === 0) {
                                allMembershipData[index].Inklusiv.push({
                                    Bezeichnung: f.Bezeichnung,
                                    Sortierung: f.Sortierung,
                                    Reihenfolge: 2
                                });
                            }
                        }
                    });

                }).catch(function () {
                allMembershipData[index].priceIsLoading = false;
                // TODO: Fehler
            })
        }

        vm.selectSurvey = function (survey, adds, mNr) {

                if (!survey.priceIsLoading && vm.selectedSurvey.length > 0) {
                    if (_.isUndefined(vm.choosenMembershipIndexOrig) || vm.choosenMembershipIndexOrig === false || vm.choosenMembershipIndex !== vm.choosenMembershipIndexOrig) {
                        vm.parent.selectSurvey(survey, adds, mNr, vm.memberships,  null, vm.choosenNewangebotForMember, vm.member, vm.memberSelected, vm.choosenMembershipIndex);
                    }
                    if (vm.choosenMembershipIndex === vm.choosenMembershipIndexOrig) {
                        vm.changedMitgliedschaft = false;
                        vm.parent.selectSurvey(vm.parent.selectedSurvey ? vm.parent.selectedSurvey : vm.selectedSurvey[0], adds, mNr, vm.memberships, vm.parent.selectedMembershipAdds, vm.choosenNewangebotForMember, vm.member, vm.memberSelected, vm.choosenMembershipIndex, vm.parent.selectedAdditions, vm.parent.selectedAdditionsPauschalen, vm.parent.selectedAdditionsGebuehren, vm.parent.selectedAdditionsGesamt, vm.parent.pflichtZusatztarifePreis, vm.selectedPauschalenWithMembershipZyklus, vm.selectedPauschalenWithMembershipZyklusIds);
                    } else {
                        vm.changedMitgliedschaft = true;
                        vm.textInfoChangedMitgliedschaft = "T_TextInfoChangedMitgliedschaft";

                    }
                }

        };

        vm.selectAnotherSurvey = function (survey, adds, mNr) {
            vm.parent.selectSurvey(survey, adds, mNr, vm.memberships, vm.choosenNewangebotForMember, vm.member, vm.memberSelected, vm.choosenMembershipIndex);
        }

        function checkInklusiv(prices, index) {


        }

        function checkFreeServices(prices) {
            let hasServicesWithoutPrice = false;
            _.forEach(prices.Pauschalenpreise, function (value) {
                if (value === 0)
                    hasServicesWithoutPrice = true;
            });

            if (!hasServicesWithoutPrice) {
                _.forEach(prices.Zusatztarifpreise, function (value) {
                    if (value === 0)
                        hasServicesWithoutPrice = true;
                });
            }

            return hasServicesWithoutPrice;
        }

        function parseUnits(value, unit) {
            if (!value || !unit)
                return "";
            return value + " " + $translate.instant(cycleUnits[unit][(value === 1) ? 0 : 1]);
        }

        function parseCycles(value, unit) {
            // if (!value || !unit)
            //     return "";

            if (value === 0)
                return $translate.instant("T_einmalig");

            return ((value > 1) ? value + "-" : "") + $translate.instant(cycleUnits[unit][2]);
        }

        function getLimits() {
            switch (true) {
                case ($window.innerWidth >= 2500):
                    vm.limitLengthMemberships = 7;
                    return 7;
                case ($window.innerWidth >= 2100):
                    vm.limitLengthMemberships = 6;
                    return 6;
                case ($window.innerWidth >= 1700):
                    vm.limitLengthMemberships = 5;
                    return 5;
                case ($window.innerWidth >= 1300):
                    vm.limitLengthMemberships = 4;
                    return 4;
                case ($window.innerWidth >= 900):
                    vm.limitLengthMemberships = 3;
                    return 3;
                case ($window.innerWidth >= 700):
                    vm.limitLengthMemberships = 2;
                    return 2;
                default:
                    vm.limitLengthMemberships = 1;
                    return 1;
            }
        }

        vm.chooseSurvey = function (survey, index, adds, mNr) {
            if(vm.parent.angebot) {
                if (index === vm.choosenMembershipIndexOrig || _.isUndefined(vm.choosenMembershipIndexOrig) || vm.choosenMembershipIndexOrig === false || vm.choosenMembershipIndex===null) {
                    vm.changedMitgliedschaft = false;
                } else {
                    vm.changedMitgliedschaft = true;
                    vm.textInfoChangedMitgliedschaft = "T_TextInfoChangedMitgliedschaft";
                    if (vm.parent.selectedSurvey) {
                        if (vm.parent.selectedSurvey.AngebotId) {
                            survey.AngebotId = vm.parent.selectedSurvey.AngebotId;
                        }
                    }
                    if (vm.selectedSurvey && vm.selectedSurvey.length>0) {
                        if (vm.selectedSurvey[0].AngebotId) {
                            survey.AngebotId = vm.selectedSurvey[0].AngebotId;
                        }
                    }
                }
                vm.selectedSurvey = [];
                //vm.surveySelected = survey;
                vm.isSelectedSurvey = true;
                vm.choosenMembershipIndex = index;
                if (!_.includes(vm.selectedSurvey, survey)) {
                    vm.selectedSurvey.push(survey);
                } else {
                    _.pull(vm.selectedSurvey, survey);
                }
            } else {
                if (!survey.priceIsLoading) {
                    vm.parent.selectSurvey(survey, adds, mNr, vm.memberships, vm.choosenNewangebotForMember, vm.member, vm.memberSelected, vm.choosenMembershipIndex);
                }
            }

        }

        vm.goToClubs = function () {
            if (!vm.parent.memberSelected) {
                vm.parent.goToClubs('clubs', false, vm.parent.selectedMember, vm.choosenMemberAngebot, vm.selectedFoundAngebot, true, true, vm.parent.choosenClubIndex, vm.selectedMandantNr)
            } else {
                vm.parent.goBackActions();

            }
        }
    }]);